import { css } from '@emotion/core';

import { DRAWER_INNER_WIDTH, MODAL_WIDTH } from '@client/utils/constants';

const fieldWidth = `${DRAWER_INNER_WIDTH}px`;
const modalFieldWidth = `${MODAL_WIDTH}px`;
const wideFieldWidth = '1200px';

export const mountedFormCss = (layout) => {
  let width;
  let verticalMargin;

  switch (layout) {
    case 'wide':
      width = wideFieldWidth;
      verticalMargin = '20px';
      break;
    case 'two-column':
      width = fieldWidth;
      verticalMargin = '15px';
      break;
    case 'two-column-modal':
    case 'modal':
      width = modalFieldWidth;
      verticalMargin = '10px';
      break;
    default:
      width = fieldWidth;
      verticalMargin = '10px';
  }

  return css`
    display: flex;
    flex-direction: column;
    margin: ${verticalMargin} 0;
    max-width: 100%;
    width: ${width};
  `;
};

export const mountedLabelCss = css`
  display: inline-flex;
  align-items: flex-start;
  gap: 0.3rem;
  color: #5b5a61;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;  
`;

export const mountedLabelRequiredCss = css`
  position: relative;
  margin-top: -15px;
  transform: translateY(15px);
`;

export const tooltipIconCss = {
  root: css({
    width: '16px',
  })
};

export const tooltipDialogCss = {
  dialog: {
    root: css({
      zIndex: 401, // the drawer is using 400
      maxWidth: '300px',
      border: 'none',
      textAlign: 'left',
    })
  },
};
